<template>
    <div>
        
        <Header />
        
        <BannerProjects :title="project.name"/>

        <section class="portfolio_details_area p_120">
            <div class="container">
                <div class="portfolio_details_inner">
                    <div class="row">
                        <div class="col-md-6">
                        <div class="left_img">
                            <div id="carouselExampleIndicators" data-ride="carousel" class="carousel slide">
                                
                                <ol class="carousel-indicators">
                                    <li v-for="(image, index) in imagesOfProject[0]" data-target="#carouselExampleIndicators" :data-slide-to="index" v-bind:class="{ 'active': index == 0 }"></li>
                                </ol>

                                <div class="carousel-inner">
                                    
                                    <div class="carousel-item" v-for="(image, index) in imagesOfProject[0]" v-bind:class="{ 'active': index == 0 }">
                                        <img :src="returnImage(image.link)" :alt="image.name" class="img-fluid">
                                        <div class="carousel-caption d-none d-md-block">
                                            <h5>{{image.name}}</h5>
                                        </div>
                                    </div>
                                    
                                </div>
                                

                                <a href="#carouselExampleIndicators" role="button" data-slide="prev" class="carousel-control-prev">
                                    <span aria-hidden="true" class="carousel-control-prev-icon"></span>
                                    <span class="sr-only">Anterior</span>
                                </a>

                                <a href="#carouselExampleIndicators" role="button" data-slide="next" class="carousel-control-next">
                                    <span aria-hidden="true" class="carousel-control-next-icon"></span>
                                    <span class="sr-only">Próximo</span>
                                </a>

                            </div>
                        </div>
                        </div>
                        <div class="col-md-6">
                        <div class="portfolio_right_text">
                            <h4>{{project.name}}</h4>
                            <p>{{project.description}}</p>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <Clients />

        <Footer />

        
    </div>
</template>

<script>

    import axios from 'axios';
    import Vue from 'vue';
    import SmoothScroll from 'smooth-scroll';
    import $ from 'jquery';

    import Header from '../components/header';
    import BannerProjects from '../components/banner_projects';

    import Clients from '../components/clients';
    import Footer from '../components/footer';
    
    import {apiURL} from '../resources/apiUrl';

    let axiosInstance = axios.create();

export default {
    
    name: 'projetoDetalhe',

    components: {
        Header,
        BannerProjects,
        Clients,
        Footer
    },
    
    data: function () {
        return {
            project: {},
            imagesOfProject: [],
        }
    }, 
    created() {

        axiosInstance.get(`${apiURL()}/lp/projects/${this.$route.params.id}`)
            .then(response => {
                this.project = response.data;
                this.returnImagesFromProject(this.project.id);
            })
            .catch(error => {
                console.log(error);
            })

    },

    mounted() {
        let nav_offset_top = $('header').height() + 50;
        
        if ( $('.header_area').length ){ 
            $(window).scroll(function() {
                var scroll = $(window).scrollTop();   
                if (scroll >= nav_offset_top ) {
                    $(".header_area").addClass("navbar_fixed");
                } else {
                    $(".header_area").removeClass("navbar_fixed");
                }
            })
        }

        let scroll = new SmoothScroll('a[href*="#"]');
        
        $('.nav a').on('click', function(){
            $('.navbar-toggler').click();
        });
    },

    methods: {
        
        returnImagesFromProject(id){
            axiosInstance.get(`${apiURL()}/lp/images/project/${id}`)
                .then(response => {
                    this.imagesOfProject.push(response.data);
                    console.log(this.imagesOfProject[0]);
                })
                .catch(error => {
                    console.log(error);
                })
        },

        returnImage(linkImage){
            return `${apiURL()}/lp/images/${linkImage}`;
        }

    }
}
</script>

<style>

</style>